import { secondsToMilliseconds } from '@/Shared/lib/secondsToMilliseconds';

import { StationLogFileResource } from '../api/StationLogFileResource';
import { StationLogFileModel } from '../model/StationLogFileModel';

export const mapStationLogFileResourceToModel = (resource: StationLogFileResource): StationLogFileModel => {
    return {
        ...resource,
        m_time: new Date(secondsToMilliseconds(resource.m_time)),
    };
};
